import { useUser } from "@clerk/clerk-react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import type { ModuleId } from "@/lib/modules";
import { hasModuleAccess } from "@/lib/modules";

interface ModuleGuardProps {
  moduleId: ModuleId;
  children: ReactNode;
}

/**
 * Redirects to /dashboard when the authenticated user lacks entitlement to
 * `moduleId` (checked via Clerk publicMetadata.modules).
 */
export function ModuleGuard({ moduleId, children }: ModuleGuardProps) {
  const { user } = useUser();
  if (!hasModuleAccess(user?.publicMetadata, moduleId)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
